$(document).ready(function () {
  // Enable checkboxes after page load
  $("input[type='checkbox']").prop("disabled", false);

  // Scroll to top on page load
  $(window).on('beforeunload', function(){
    $(window).scrollTop(0);
  });

  // Show/Hide header tabs
  $(".tab").click(function () {
    $(".tab-content").removeClass("active-tab-content");
    $(".tab-content[data-id='" + $(this).attr("data-id") + "']").addClass("active-tab-content");
    $(".tab").removeClass("active-tab");
    $(this).parent().find(".tab").addClass("active-tab");
    $("#searchbar").val("").trigger("keyup"); // Clear search
    // Scroll up to top on switching tabs
    $("html, body").animate({ scrollTop: 0 }, 500, "swing");
  });

  // Sticky header on-scroll
  $(window).scroll(function (event) {
    var height = $(window).height();
    var scroll = $(window).scrollTop();
    if (scroll > height) {
      $(".sticky-header").addClass("show");
    } else {
      $(".sticky-header").removeClass("show");
    }
  });

  // Passing line-items on clicking submit button - FIXED to pass ALL checked items
  $("#submit-btn").click(function () {
    const cartObject = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const formData = new FormData();
    
    // Add main product
    formData.append('items[][id]', $("#crazyDealsPID").find(":selected").val());
    formData.append('items[][quantity]', '1');
    formData.append('items[][properties[_bundle_product1]]', $("#mainprd-sku").val() + '/0/1');
    
    // Calculate total price from ALL checked items
    var total_price = 0;
    $("#flexi-box-form").find(".add-to-box input:checked ").each(function () {
      if ($(this).val() !== "No") {
        total_price += parseFloat($(this).data("price")) || 0;
      }
    });

    // FIXED: Pass ALL checked line items properly
    let items = 1;
    $("#flexi-box-form").find(".add-to-box input:checked").each(function () {
      if ($(this).val() !== "No") {
        items++;
        
        const productValue = $(this).val();
        const productSku = $(this).data('sku');
        const productPrice = parseFloat($(this).data('price')) || 0;
        const mainPrice = parseFloat($(this).data('main-price')) || 0;
        const productQuantity = $(this).data('quantity');
        
        // Calculate proportional price for bundle
        const proportionalPrice = total_price > 0 
          ? Math.round((productPrice / total_price) * mainPrice * 100) / 100 
          : 0;
        
        // Append ITEM property
        formData.append('items[][properties[ITEM' + (items - 1) + ']]', productValue);
        
        // Append bundle product property
        formData.append('items[][properties[_bundle_product' + items + ']]', productSku + '/' + proportionalPrice + '/' + productQuantity);
      }
    });

    // Add cart sections for rendering
    if (cartObject) {
      formData.append(
        'sections',
        cartObject.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    // Show loading state
    const $btn = $("#submit-btn");
    const originalText = $btn.text();
    $btn.prop("disabled", true).text("Adding...");

    // Fetch request
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add items to cart');
      }
      return response.json();
    })
    .then(data => {
      console.log('Items added successfully:', data);
      if (cartObject) {
        cartObject.classList.remove('is-empty');
        cartObject.renderContents(data);
      } else {
        // Fallback redirect
        window.location.href = '/cart';
      }
      $btn.prop("disabled", false).text(originalText);
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('Error adding items to cart. Please try again.');
      $btn.prop("disabled", false).text(originalText);
    });

    return false;
  });

  // Store initial checkbox values
  const totalTabs = $(".tab").length;
  let checkboxes = $("input[type='checkbox']");
  
  const initProdValues = {};
  checkboxes.each(function() {
    const checkboxId = $(this).attr('id');
    const checkboxValue = $(this).val().trim();
    initProdValues[checkboxId] = checkboxValue;
  });

  // Checkbox click functionality code - FIXED selector for accurate count
  checkboxes.click(function () {
    const checkboxId = this.id;
    const initProductValue = initProdValues[checkboxId];
    const currProductValue = $(this).val().trim();
    
    // Only reload if values actually changed
    if (initProductValue && currProductValue && currProductValue !== initProductValue) {
      location.reload();
      return false;
    }
    
    const currProduct = $(this).attr("data-id");
    const currProductDataId = $(this).attr("data-id-products");
    const currTabId = Number(currProductDataId.split("_")[1]);
    const selectionLimit = $('.tab-content[data-id="tab' + currTabId + '"]').attr("data-product-limit");
    
    // Hide added indicators
    $(this).parents(".product-info").find(".added_to_cart").addClass("_hidden");
    $(this).parents(".product-info").find(".product_counter").addClass("_hidden");
    
    // Show indicators if checked
    if ($(this).is(":checked")) {
      $(this).parents(".product-info").find(".added_to_cart").removeClass("_hidden");
      $(this).parents(".product-info").find(".product_counter").removeClass("_hidden");
      
      // Show success message
      const productTitle = $(this).val().split(" SKU:")[0];
      $(".Message_Bar").removeClass("is-hidden");
      $(".Message_Bar p span").text(productTitle);
      setTimeout(function () {
        $(".Message_Bar").addClass("is-hidden");
        $(".Message_Bar p span").text("");
      }, 2500);
    }
    
    // Count checked items in current tab
    let n = $("input[data-id-products='tab_" + currTabId + "_product']:checked").length;
    
    // Disable/enable unchecked items based on selection limit
    if (n == selectionLimit) {
      $("[data-id=tab" + currTabId + "] input:not(:checked)").prop("disabled", true);
    } else {
      $("[data-id=tab" + currTabId + "] input:not(:checked)").prop("disabled", false);
    }

    // Show/Hide bubble counts and tick on completing selection limit
    if (n == selectionLimit) {
      $("#checkbox_count_" + currProductDataId).css("display", "inline-block");
      $("#checkbox_count_" + currProductDataId).html(
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" class="check-icon"><path d="M10.0007 15.1709L19.1931 5.97852L20.6073 7.39273L10.0007 17.9993L3.63672 11.6354L5.05093 10.2212L10.0007 15.1709Z" fill="rgba(255,255,255,1)"></path></svg>'
      );
    } else if (n > 0) {
      $("#checkbox_count_" + currProductDataId).css("display", "inline-block");
      $("#checkbox_count_" + currProductDataId).html(n);
    } else {
      $("#checkbox_count_" + currProductDataId).css("display", "none");
    }

    // Switching tabs after adding mandatory items
    if (n == selectionLimit) {
      
      const nextTab = "tab" + (currTabId + 1);
      $(`.tab[data-id='${nextTab}']`).click();
      $("#searchbar").val("").trigger("keyup");
      
      //  $("html, body").animate({ scrollTop: 0 }, 500, "swing");
    }

    // Enabling submit btn if all mandatory products are selected
    if ($(".add-to-box input:checked").length == totalproductSelection) {
      $("#submit-btn").css("display", "inline-block");
    } else {
      $("#submit-btn").css("display", "none");
    }
  });

  // Disable inspect element Right click and F12 key
  $(document).bind("contextmenu", function (e) {
    e.preventDefault();
  });
  
  $(document).keydown(function (e) {
    if (e.which === 123) {
      return false;
    }
  });

  // JS code for custom search bar
  $("#searchbar").on("keyup", function () {
    var value = $(this).val().toLowerCase();
    $("#collection-list li").filter(function () {
      $(this).toggle(
        $(this).find("a").text().toLowerCase().indexOf(value) > -1
      );
    });
  });
  
  // Clear search on pressing clear button
  $(".search-clear").click(function (e) {
    e.preventDefault();
    $("#searchbar").val("").trigger("keyup");
  });

  


}); // document.ready ends here